import { withPrefix } from 'gatsby'

const ASSETS_BASE_URL = withPrefix('/assets/img')
const AUDIOS_BASE_URL = withPrefix('/assets/audio')

export const HOME_SHOTS = {
  shotRombo: {
    mobile: `${ASSETS_BASE_URL}/home/img-rombo.png`,
    desktop: `${ASSETS_BASE_URL}/home/img-rombo-pc.png`,
  },
}

export const HOME_ELEMENST = {
  plataformaRosa: {
    mobile: `${ASSETS_BASE_URL}/home/plataforma-rosa-mb.png`,
    desktop: `${ASSETS_BASE_URL}/home/plataforma-rosa-pc.png`,
  },
  gotaRoja: {
    mobile: `${ASSETS_BASE_URL}/home/gota-roja-mb.png`,
    desktop: `${ASSETS_BASE_URL}/home/gota-roja-pc.png`,
  },
  logo: {
    mobile: `${ASSETS_BASE_URL}/home/titulo-juego-mb.png`,
    desktop: `${ASSETS_BASE_URL}/home/titulo-juego-pc.png`,
  },
  plataformaPuntos: {
    mobile: `${ASSETS_BASE_URL}/home/plataforma-puntos-mb.png`,
    desktop: `${ASSETS_BASE_URL}/home/plataforma-puntos-pc.png`,
  },
  plataformaToalla: `${ASSETS_BASE_URL}/home/plataforma-toalla.png`,
  toalla: `${ASSETS_BASE_URL}/home/toalla.png`,
  flechaRosa: `${ASSETS_BASE_URL}/home/flecha-rosa.png`,
  botonFinalizar: {
    mobile: `${ASSETS_BASE_URL}/home/boton-finalizar-mb.png`,
    desktop: `${ASSETS_BASE_URL}/home/boton-finalizar-pc.png`,
  },
  shooterButton: `${ASSETS_BASE_URL}/home/shooter-img.png`,
  cuadroPregunta: {
    mobile: `${ASSETS_BASE_URL}/home/cuadro-pregunta.png`,
    desktop: `${ASSETS_BASE_URL}/home/cuadro-pregunta-pc.png`,
  },
  alertOnePoints: {
    mobile: `${ASSETS_BASE_URL}/home/plus-one-point.png`,
    desktop: `${ASSETS_BASE_URL}/home/plus-one-point-pc.png`,
  },
  alertThreePoints: {
    mobile: `${ASSETS_BASE_URL}/home/plus-three-point.png`,
    desktop: `${ASSETS_BASE_URL}/home/plus-three-point-pc.png`,
  },
  alertSixPoints: {
    mobile: `${ASSETS_BASE_URL}/home/plus-six-point.png`,
    desktop: `${ASSETS_BASE_URL}/home/plus-six-point-pc.png`,
  },
  ...HOME_SHOTS,
}

export const HOME_SPRITE_SHEETS = [
  {
    key: 'boom',
    url: `${ASSETS_BASE_URL}/home/explosion4.png`,
    frameWidth: 64,
    frameHeight: 64,
  },
]

export const HOME_SOUNDS = {
  spaceLaser: `${AUDIOS_BASE_URL}/space-laser-gun.mp3`,
  smokeBomb: `${AUDIOS_BASE_URL}/smoke-bomb.mp3`,
}
